import React from "react";
import PropTypes from "prop-types";

import { Column, Field, Control, Label, Input } from "rbx";

import {
  BooleanInput,
  PhoneNumberInput,
  StateSelect,
  ZipCodeInput
} from "../inputs";

const VendorForm = ({ inputs, onChange }) => (
  <React.Fragment>
    <Column.Group>
      <Column>
        <Field kind="group">
          <Control expanded>
            <Label>Name</Label>
            <Input
              required
              autocomplete="new"
              name="Name"
              type="text"
              value={inputs.Name}
              onChange={onChange}
            />
          </Control>
          <Control>
            <Label>Active</Label>
            <BooleanInput
              name="Active"
              value={inputs.Active}
              onChange={onChange}
            />
          </Control>
        </Field>
        <Field kind="group">
          <Control expanded>
            <Label>Address1</Label>
            <Input
              autocomplete="new"
              name="Address1"
              type="text"
              value={inputs.Address1}
              onChange={onChange}
            />
          </Control>
          <Control expanded>
            <Label>Address2</Label>
            <Input
              autocomplete="new"
              name="Address2"
              type="text"
              value={inputs.Address2}
              onChange={onChange}
            />
          </Control>
        </Field>
        <Field kind="group">
          <Control expanded>
            <Label>Contact</Label>
            <Input
              autocomplete="new"
              name="Contact"
              type="text"
              value={inputs.Contact}
              onChange={onChange}
            />
          </Control>
          <Control expanded>
            <Label>Phone #</Label>
            <PhoneNumberInput
              name="Telephone"
              value={inputs.Telephone}
              onChange={onChange}
            />
          </Control>
        </Field>
      </Column>
      <Column>
        <Field kind="group">
          <Control expanded>
            <Label>Website</Label>
            <Input
              autocomplete="new"
              name="WebSite"
              type="text"
              value={inputs.WebSite}
              onChange={onChange}
            />
          </Control>
        </Field>
        <Field kind="group">
          <Control expanded>
            <Label>City</Label>
            <Input
              autocomplete="new"
              name="City"
              type="text"
              value={inputs.City}
              onChange={onChange}
            />
          </Control>
          <Control expanded>
            <Label>State</Label>
            <StateSelect
              name="State"
              value={inputs.State}
              onChange={onChange}
            />
          </Control>
          <Control expanded>
            <Label>Zip</Label>
            <ZipCodeInput
              autocomplete="new"
              name="Zip"
              type="text"
              value={inputs.Zip}
              onChange={onChange}
            />
          </Control>
        </Field>
        <Field kind="group">
          <Control expanded>
            <Label>Fax #</Label>
            <PhoneNumberInput
              name="Fax"
              value={inputs.Fax}
              onChange={onChange}
            />
          </Control>
          <Control expanded>
            <Label>Email</Label>
            <Input
              autocomplete="new"
              name="EmailAddr"
              type="text"
              value={inputs.EmailAddr}
              onChange={onChange}
            />
          </Control>
        </Field>
      </Column>
    </Column.Group>
  </React.Fragment>
);
VendorForm.propTypes = {
  inputs: PropTypes.object,
  onChange: PropTypes.func
};

VendorForm.defaultProps = {
  inputs: {}
};
export default VendorForm;
